export default __webpack_public_path__ + "static/media/WEG2.ed8317e7.jpg";